import React, { useEffect, useState } from "react";
import { TextField, Button, Typography, Slider, Checkbox } from "@mui/material";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { SecondAds, FirstAds, MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";
const TITLE = "مولد كلمات السر العشوائية والقوية - إنشاء كلمة مرور معقدة وآمنة";
const DESCRIPTION = "مولد كلمات سر قوية وعشوائية لجميع حساباتك! أنشئ كلمة مرور معقدة وصعبة باستخدام مزيج من الأحرف والأرقام والرموز. اختر بين 12 إلى 100 حرفاً للحصول على أقصى درجات الأمان والحماية لحساباتك الشخصية";
const KEYWORDS = "مولد كلمات السر، كلمة مرور معقدة، كلمة مرور صعبة، كلمة مرور عشوائية، كلمات سر صعبه، مولد كلمة المرور، كلمات مرور قوية، إنشاء كلمة سر، مولد كلمة سر عشوائية، حماية الحسابات، أمان الإنترنت، تأمين البيانات، كلمة مرور قوية، مولد كلمة مرور عشوائي، أحرف وأرقام ورموز";
const OG_URL = "https://do-calculate.com/calculator/ar/random-password-generator";
function PasswordGenerator() {
  const [passwordLength, setPasswordLength] = useState(8);
  const [includeLowercase, setIncludeLowercase] = useState(true);
  const [includeUppercase, setIncludeUppercase] = useState(true);
  const [includeNumbers, setIncludeNumbers] = useState(true);
  const [includeSymbols, setIncludeSymbols] = useState(true);
  const [excludeAmbiguous, setExcludeAmbiguous] = useState(true);
  const [excludeBrackets, setExcludeBrackets] = useState(true);
  const [noRepeatedChars, setNoRepeatedChars] = useState(false);
  const [generatedPassword, setGeneratedPassword] = useState("");
  const [passwordStrength, setPasswordStrength] = useState("");
  const [passwordEntropy, setPasswordEntropy] = useState(0);
  const [error, setError] = useState("");
  useEffect(() => {
    generatePassword();
  }, [
    passwordLength,
    includeLowercase,
    includeUppercase,
    includeNumbers,
    includeSymbols,
    excludeAmbiguous,
    excludeBrackets,
    noRepeatedChars,
  ]);
  useEffect(() => {
    calculatePasswordEntropy();
    evaluatePasswordStrength();
  }, [generatedPassword]);
  const calculatePasswordEntropy = () => {
    let charsetSize = 0;
    const excludedChars = excludeAmbiguous ? "iIl1L|o0O'\";:., " : "";
    const excludedBrackets = excludeBrackets ? "[]<>()" : "";
    if (includeLowercase) {
      charsetSize += 26;
    }
    if (includeUppercase) {
      charsetSize += 26;
    }
    if (includeNumbers) {
      charsetSize += 10;
    }
    if (includeSymbols) {
      const allowedSymbols = "!@#$%^&*_+=-|~";
      const filteredSymbols = allowedSymbols
        .split("")
        .filter(
          (symbol) =>
            !excludedChars.includes(symbol) &&
            !excludedBrackets.includes(symbol)
        );
      charsetSize += filteredSymbols.length;
    }
    const patternEntropy = calculatePatternEntropy();
    const passwordEntropy = Math.log2(Math.pow(charsetSize, passwordLength));
    const repeatedCharacterEntropy = calculateRepeatedCharacterEntropy();
    setPasswordEntropy(
      Math.max(
        passwordEntropy + patternEntropy + repeatedCharacterEntropy,
        0
      ).toFixed(1)
    );
  };
  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(generatedPassword);

    } catch (err) {
      console.error("Failed to copy: ", err);
    }
  };

  const calculatePatternEntropy = () => {
    const patterns = [
      /\d{2,}/,
      /[a-z]{2,}/,
      /[A-Z]{2,}/,
      /[^a-zA-Z0-9]{2,}/,
    ];
    let patternEntropy = 0;
    patterns.forEach((pattern) => {
      const matches = generatedPassword.match(pattern);
      if (matches) {
        const patternLength = matches.reduce(
          (total, match) => total + match.length,
          0
        );
        patternEntropy += Math.log2(patternLength);
      }
    });
    return -patternEntropy;
  };
  const calculateRepeatedCharacterEntropy = () => {
    const repeatedCharacters = generatedPassword.match(/(.)\1+/g);
    if (repeatedCharacters) {
      const repeatedCharactersCount = repeatedCharacters.reduce(
        (total, match) => total + match.length - 1,
        0
      );
      const uniqueCharacterCount = passwordLength - repeatedCharactersCount;
      return Math.log2(uniqueCharacterCount);
    }
    return 0;
  };
  const evaluatePasswordStrength = () => {
    if (passwordEntropy === 0) {
      setPasswordStrength("");
    } else if (passwordEntropy < 28) {
      setPasswordStrength("ضعيفة جدا");
    } else if (passwordEntropy < 36) {
      setPasswordStrength("ضعيفة");
    } else if (passwordEntropy < 60) {
      setPasswordStrength("جيدة");
    } else if (passwordEntropy < 128) {
      setPasswordStrength("قوية");
    } else {
      setPasswordStrength("قوية جدا");
    }
  };
  const generatePassword = () => {
    let charset = "";
    if (includeLowercase) charset += "abcdefghijklmnopqrstuvwxyz";
    if (includeUppercase) charset += "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    if (includeNumbers) charset += "0123456789";
    if (includeSymbols) charset += "!@#$%^&*()_+-=[]{}|;:,.<>?";
    if (excludeAmbiguous) {
      charset = charset.replace(/[iIl1L|o0O`'";:.,]/g, "");
    }
    if (excludeBrackets) {
      charset = charset.replace(/[(){}[\]<>]/g, "");
    }
    if (charset.length === 0) {
      setError(
        "يرجى تضمين مجموعة أحرف واحدة على الأقل لكلمة المرور التي سيتم الاعتماد عليها."
      );
      return;
    }
    if (noRepeatedChars && passwordLength > charset.length) {
      setError(
        "لا توجد أحرف كافية لإنشاء كلمة المرور هذه الرجاء تضمين المزيد من مجموعات الأحرف."
      );
      return;
    }
    let generatedPassword = "";
    for (let i = 0; i < passwordLength; i++) {
      const randomIndex = Math.floor(Math.random() * charset.length);
      generatedPassword += charset.charAt(randomIndex);
      charset = charset.replace(charset.charAt(randomIndex), "");
    }
    setGeneratedPassword(generatedPassword);
    setError("");
  };
  const handleSliderChange = (event, value) => {
    setPasswordLength(value);
  };
  const handleCheckboxChange = (event) => {
    const { name, checked } = event.target;
    switch (name) {
      case "includeLowercase":
        setIncludeLowercase(checked);
        break;
      case "includeUppercase":
        setIncludeUppercase(checked);
        break;
      case "includeNumbers":
        setIncludeNumbers(checked);
        break;
      case "includeSymbols":
        setIncludeSymbols(checked);
        break;
      case "excludeAmbiguous":
        setExcludeAmbiguous(checked);
        break;
      case "excludeBrackets":
        setExcludeBrackets(checked);
        break;
      case "noRepeatedChars":
        setNoRepeatedChars(checked);
        break;
      default:
        break;
    }
  };
  return (
    <div className="rtl">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  مولد كلمة السر هو أداة تُستخدم لإنشاء كلمات مرور عشوائية
                  وقوية. يهدف الغرض من استخدام هذه الأداة إلى تعزيز أمان حساباتك
                  على الإنترنت، حيث يمكن أن تكون كلمات المرور القوية صعبة التنبؤ
                  والكسر.
                </p>
                <p>
                  يمكن لهذه الأداة إنشاء كلمات مرور آمنة وقوية وعشوائية. ولضمان
                  الأمان، يتم إنشاء كلمة المرور بالكامل على صفحة الويب دون
                  إرسالها عبر الإنترنت.
                </p>
                <p>
                  فوائد استخدام مولد كلمة السر حماية ضد الاختراق باستخدام كلمات
                  مرور قوية وعشوائية، يتم تعزيز الحماية ضد محاولات الاختراق
                  واستنساخ الحسابات. تأمين البيانات الحساسة تقليل احتمال تسريب
                  بياناتك الحساسة عبر الإنترنت عند استخدام كلمات مرور صعبة
                  التوقع. سهولة التذكر يقوم مولد كلمة السر بإنشاء كلمات مرور
                  بشكل تلقائي، مما يُحد من عبء تذكر كلمات المرور المعقدة.
                </p>
                <hr />
              </div>
              <br />
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col-sm-12 col-md-12">
                {generatedPassword && !error && (
                  <div className="mb-2">
                    <Typography
                      className="ltr"
                      fontSize="20px"
                      fontWeight="bold"
                      sx={{ wordWrap: "break-word", textAlign: "center" }}
                    >
                      {generatedPassword}
                    </Typography>
                    <Typography fontSize="18px">
                      قوة كلمة المرور :{" "}
                      <span
                        style={{
                          color:
                            passwordStrength === "ضعيفة جدا"
                              ? "rgb(255, 0, 0)"
                              : passwordStrength === "ضعيفة"
                                ? "rgb(255, 102, 0)"
                                : passwordStrength === "جيدة"
                                  ? "rgb(102, 204, 102)"
                                  : passwordStrength === "قوية"
                                    ? "rgb(51, 204, 51)"
                                    : "rgb(0, 153, 0)",
                        }}
                      >
                        {passwordStrength}
                      </span>
                    </Typography>
                    <Typography fontSize="18px" sx={{ mb: "15px" }}>
                      إنتروبيا كلمة المرور : {passwordEntropy} bits
                    </Typography>
                    <div className="d-flex">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        height="24"
                        viewBox="0 0 24 24"
                        width="24"
                        fill="currentColor"
                        style={{ marginLeft: "5px" }}
                      >
                        <path d="M16 1H4c-1.1 0-2 .9-2 2v12h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z" />
                      </svg>

                      <Typography
                        onClick={handleCopy}
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: "6px",
                          color: "rgb(102, 204, 102)",
                          textDecoration: "underline",
                          fontSize: "18px",
                          width: "fit-content",
                          "&:hover": {
                            color: "rgb(23 158 23)",
                            textDecoration: "none",
                            cursor: "pointer",
                          },
                        }}
                      >
                        نسخ كلمة المرور
                      </Typography>
                    </div>

                  </div>
                )}
                {error && (
                  <Typography
                    variant="body2"
                    color="error"
                    fontSize="16px"
                    sx={{ my: 2 }}
                  >
                    {error}
                  </Typography>
                )}
              </div>
              <div className="col-sm-12 col-md-12 calculatorStyle">
                <div
                  className="mb-3 mt-2 d-flex"
                  style={{ alignItems: "center" }}
                >
                  <label>طول كلمة السر </label>
                  <TextField
                    value={passwordLength}
                    onChange={(e) => {
                      let value = e.target.value;
                      if (value !== "" && (value < 8 || value > 50)) {
                        value = Math.min(Math.max(value, 8), 50);
                      }
                      setPasswordLength(value);
                    }}
                    sx={{
                      width: "150px",
                      mr: "15px",
                      bgcolor: "#f9f9f9",
                      "&  .MuiFormHelperText-root.Mui-error": {
                        backgroundColor: "rgb(229, 230, 227) !important",
                        margin: 0,
                      },
                    }}
                    type="number"
                    InputProps={{
                      inputProps: {
                        min: 8,
                        max: 50,
                      },
                    }}
                    size="small"
                    color="success"
                  />
                </div>
                <div className="mb-2" style={{ width: "60%" }}>
                  <Slider
                    value={passwordLength}
                    onChange={handleSliderChange}
                    color="success"
                    sx={{ marginRight: "100px", marginLeft: "100px" }}
                    min={8}
                    max={50}
                    step={1}
                    marks={[
                      { value: 8, label: "8" },
                      { value: 20, label: "20" },
                      { value: 35, label: "35" },
                      { value: 50, label: "50" },
                    ]}
                  />
                </div>
                <div className="mb-2">
                  <Checkbox
                    checked={includeLowercase}
                    onChange={handleCheckboxChange}
                    name="includeLowercase"
                    color="success"
                  />
                  تضمين الأحرف الصغيرة (a-z)
                </div>
                <div className="mb-2">
                  <Checkbox
                    checked={includeUppercase}
                    onChange={handleCheckboxChange}
                    name="includeUppercase"
                    color="success"
                  />
                  تضمين الأحرف الكبيرة (A-Z)
                </div>
                <div className="mb-2">
                  <Checkbox
                    checked={includeNumbers}
                    onChange={handleCheckboxChange}
                    name="includeNumbers"
                    color="success"
                  />
                  تضمين الأرقام (0-9)
                </div>
                <div className="mb-2">
                  <Checkbox
                    checked={includeSymbols}
                    onChange={handleCheckboxChange}
                    name="includeSymbols"
                    color="success"
                  />
                  {`تضمين الرموز (~!@#$%^&*()_+-=:;){/}[]?><)`}
                </div>
                <div className="mb-2">
                  <Checkbox
                    checked={excludeAmbiguous}
                    onChange={handleCheckboxChange}
                    name="excludeAmbiguous"
                    color="success"
                  />
                  {`استبعاد الأحرف الغامضة (iIl1L|o0O'";:.,)`}
                </div>
                <div className="mb-2">
                  <Checkbox
                    checked={excludeBrackets}
                    onChange={handleCheckboxChange}
                    name="excludeBrackets"
                    color="success"
                  />
                  {`استبعاد الأقواس ({}، []، <>, ())`}
                </div>
                <div className="mb-2">
                  <Checkbox
                    checked={noRepeatedChars}
                    onChange={handleCheckboxChange}
                    name="noRepeatedChars"
                    color="success"
                  />
                  لا توجد أحرف متكررة
                </div>
                <div className="text-center">
                  <Button
                    variant="contained"
                    color="success"
                    onClick={generatePassword}
                  >
                    إنشاء كلمة المرور
                  </Button>
                </div>
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">
                كل ماتحتاج معرفته عن كلمات المرور :
              </div>
              <div className="info-section-body">
                <p>
                  كلمة المرور هي عادةً سلسلة من الأحرف التي قد تتضمن أحرفًا
                  وأرقامًا ورموزًا يمكن استخدامها للوصول إلى شيء ما، عادةً حساب،
                  ومنع الآخرين من الوصول إليه. في عصر الإنترنت الحالي، من
                  المحتمل أن يكون لدى معظم الأشخاص خبرة في الحصول على كلمة مرور
                  لنوع ما من الحسابات. على هذا النحو، من المهم فهم كيفية إنشاء
                  كلمة مرور قوية (أو استخدام منشئ كلمات المرور) بالإضافة إلى فهم
                  كيفية اتخاذ التدابير اللازمة لحماية كلمة المرور.
                </p>
                <hr />
                <u>
                  <h2 style={{ fontSize: "16px" }}>قوة كلمة المرور :</h2>
                </u>
                <br />
                <p>
                  قوة كلمة المرور هي مقياس لمدى فعالية كلمة المرور ضد التخمين أو
                  ضد هجمات الهاكرز. على الرغم من أنها تختلف، عادةً ما تكون قوة
                  كلمة المرور بمثابة تقدير لعدد المحاولات المطلوبة في المتوسط
                  لشخص ما لتخمين كلمة المرور بنجاح. يتأثر هذا بطول كلمة المرور
                  وتعقيدها وعدم القدرة على التنبؤ بها. على سبيل المثال، إذا كانت
                  كلمة المرور تتضمن اسم شخص ما، أو تاريخ ميلاده، أو معلومات
                  شخصية أخرى لا يصعب عادةً اكتشافها، فمن المحتمل أن تكون كلمة
                  المرور ضعيفة. بصرف النظر عن كلمة المرور الفعلية، تلعب الضوابط
                  الأمنية المناسبة دورًا مهمًا في تقليل مخاطر الاختراق الأمني.
                  تتضمن الضوابط الأمنية الضمانات المعمول بها لاكتشاف المخاطر
                  الأمنية أو تجنبها أو تقليلها. يتضمن ذلك عناصر تحكم مثل
                  المصادقة المكونة من خطوتين لكلمة المرور الخاصة بك، أو قفل
                  الحساب لفترة من الوقت بعد عدد معين من المحاولات الفاشلة.
                </p>
                <hr />
                <u>
                  <h2 style={{ fontSize: "16px" }}>
                    كيفية إنشاء كلمة مرور آمنة :
                  </h2>
                </u>
                <br />
                <p>
                  يمكن إنشاء كلمة مرور آمنة باتباع قواعد معينة مصممة لزيادة أمان
                  كلمة المرور. يتضمن هذا إلى حد كبير إنشاء كلمة مرور قوية، ولكنه
                  يتضمن جوانب أخرى مثل تغيير كلمة المرور بشكل دوري، بالإضافة إلى
                  الوعي بكلمات المرور الشائعة وتجنب استخدامها (كلمة المرور،
                  123456، qwert...). فيما يلي بعض القواعد التي يمكن استخدامها
                  لإنشاء كلمة مرور قوية:
                  <br />
                  - تضمين الحروف الصغيرة [a-z]
                  <br />
                  - تضمين الحروف الكبيرة [A-Z]
                  <br />
                  - تضمين الأرقام [0-9]
                  <br />
                  - تضمين الرموز [!@#$%^&*()...]
                  <br />
                  - استبعاد الكلمات التي تتضمن معلومات شخصية للمستخدم <br />
                  - استبعاد الكلمات الموجودة في القائمة السوداء لكلمات المرور -
                  هناك قوائم سوداء لكلمات المرور يمكن العثور عليها على الإنترنت،
                  أو من الممكن أن يكون لدى شركة / مؤسسة أخرى قوائم سوداء خاصة
                  بها لكلمات المرور
                  <br />
                  - استبعاد اسم الشركة/المؤسسة، وكذلك اختصارات الاسم
                  <br />
                  - استبعد كلمات المرور التي تطابق التنسيقات الشائعة مثل تواريخ
                  التقويم أو أرقام لوحة الترخيص أو أرقام الهواتف أو تنسيقات
                  الأرقام الشائعة الأخرى
                  <br />
                  بالإضافة إلى ذلك، تشتمل العديد من سياسات كلمة المرور عادةً على
                  الحد الأدنى لطول كلمة المرور لأنه بشكل عام، كلما كانت كلمة
                  المرور أطول، وكلما زاد تنوع أنواع الأحرف، زادت أمان كلمة
                  المرور.
                </p>
                <hr />
                <u>
                  <h2 style={{ fontSize: "16px" }}>Password entropy :</h2>
                </u>
                <br />
                <p>
                  يحدد منشئ كلمات المرور أيضًا إنتروبيا كلمة المرور، ويتم قياسها
                  بالبت. كلما ارتفعت الإنتروبيا، كلما أصبح من الصعب تخمين كلمة
                  المرور. في سياق بحث الهاكرز (حيث يتم اختبار كل الاحتمالات)،
                  فإن إنتروبيا كلمة المرور التي تبلغ 100 بت تتطلب 2100 محاولة
                  لاستنفاد جميع الاحتمالات. ومع ذلك، في المتوسط، يجب استنفاد ما
                  يقرب من نصف هذه الاحتمالات قبل العثور على الخيار الصحيح .
                </p>
                <hr />
                <u>
                  <h2 style={{ fontSize: "16px" }}>
                    كيفية حماية كلمة المرور الخاصة بك :
                  </h2>
                </u>
                <br />
                <p>
                  إن حماية كلمة المرور الخاصة بك لا تقل أهمية عن التوصل إلى كلمة
                  مرور قوية. فيما يلي بعض الإجراءات المقترحة التي يمكنك اتخاذها
                  للمساعدة في حماية كلمة المرور الخاصة بك. من المحتمل أن يكون
                  هناك إجراءات أخرى يمكن لأي شخص اتخاذها، ولكن فيما يلي بعض
                  الإرشادات التي قد تساعد: <br />- لا تشارك كلمة المرور الخاصة
                  بك مع أشخاص آخرين - من الناحية المثالية، يجب أن يكون المستخدم
                  هو الشخص الوحيد الذي يعرف كلمة المرور الخاصة به. على سبيل
                  المثال، حتى إذا كنت تثق في الشخص الذي تشارك معه كلمة المرور
                  الخاصة بك، وحتى إذا لم يكن لدى هذا الشخص أي نية خبيثة، فقد
                  يكون أقل حرصًا منك بشأن حماية كلمة المرور الخاصة بك. كلما زاد
                  عدد الأشخاص الذين يعرفون كلمة المرور الخاصة بك، زادت احتمالية
                  سرقة معلوماتك من قبل شخص آخر. <br />
                  - لا تستخدم نفس كلمة المرور عبر مواقع الويب والحسابات المختلفة
                  - على الرغم من أنه قد يكون من الأفضل استخدام نفس كلمة المرور
                  عبر مواقع الويب والحسابات المختلفة، إلا أنه ليس من المستحسن.
                  إن وجود نفس كلمة المرور لجميع حساباتك، بغض النظر عن مدى قوة
                  كلمة المرور، قد يعني أن الاختراق الأمني ​​لأي حساب واحد يعرض
                  سلامة جميع حساباتك للخطر. يمكن أن يساعدك استخدام مدير كلمات
                  المرور في إدارة كلمات المرور والحسابات الخاصة بك، وزيادة
                  الأمان من خلال السماح لك باستخدام كلمات مرور مختلفة لحسابات
                  مختلفة بسهولة أكبر. هناك عدد من برامج إدارة كلمات المرور
                  المختلفة التي يمكنك استكشافها للعثور على البرنامج الذي يناسب
                  احتياجاتك.
                  <br />
                  - قم بتغيير كلمات المرور الخاصة بك بانتظام – هذا إجراء آخر
                  يمكنك اتخاذه وهو غير مريح أيضًا، ولكنه من الناحية النظرية يمكن
                  أن يساعد في الحفاظ على أمان حساباتك. يساعد هذا في الحالات التي
                  قد يعرف فيها شخص ما كلمة المرور الخاصة بك، ويمكنه الوصول
                  إليها، ولكن قد لا يحاول على الفور القيام بشيء ضار. في هذه
                  الحالات، سيؤدي تغيير كلمة المرور الخاصة بك إلى تحديد الفترة
                  الزمنية التي يمكنهم خلالها الوصول إلى حسابك، على افتراض أنهم
                  لا يستطيعون تحديد كلمة المرور الجديدة. في الحالات التي قمت
                  فيها بحفظ كلمة المرور الخاصة بك على جهاز قديم ربما قمت ببيعه
                  أو التخلص منه، فإن تغيير كلمة المرور الخاصة بك سيؤدي إلى تعطيل
                  أي شخص من استخدام كلمة المرور المحفوظة.
                  <br />
                  - لا تقم أبدًا بحفظ كلمات المرور الخاصة بك على الأجهزة العامة
                  - من الناحية المثالية، حاول عدم حفظ كلمات المرور على الإطلاق
                  لتقليل خطر حصول الأشخاص على وصول غير مرغوب فيه إلى حساباتك.
                  وعلى نفس المنوال، كن حذرًا من الوصول إلى الحسابات الحساسة على
                  الشبكات العامة غير الآمنة.
                  <br />- لا تحتفظ بقوائم واضحة لكلمات المرور الخاصة بك والتي قد
                  يتمكن شخص ما من الوصول إليها، سواء كانت مادية أو إلكترونية -
                  على سبيل المثال، ملاحظة لاصقة على مكتبك تحتوي على الحسابات
                  وكلمات المرور الخاصة بها، أو مستند Word على سطح المكتب باسم
                  "كلمات المرور" يحتوي على معلومات لجميع حساباتك، أو ملاحظة على
                  هاتفك المحمول يمكن أن تعرضك لخطر غير ضروري بفقدان كلمة المرور.
                  كما ذكرنا أعلاه، فكر في استخدام مدير كلمات المرور بدلاً من
                  ذلك. يمكن فقدان أو سرقة الهواتف وأجهزة الكمبيوتر المحمولة وما
                  إلى ذلك. من الناحية المثالية، يجب على الشخص استخدام مدير كلمات
                  المرور أو أن يكون قادرًا على تذكر كلمات المرور الخاصة به
                  لحسابات مختلفة بناءً على الحساب المحدد.
                </p>
                <hr />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default PasswordGenerator;
